export const getEpochUrl = (
  id: string,
  epochSize: number | string,
  epochSelected: number | string
) => `/study/${id}/graphs/${epochSize}/${epochSelected}/`;

export const getReportsUrl = (id: string) => `/study/${id}/report/`;
